import { c as _c } from "react/compiler-runtime";
import './chat.scss';
import { cn } from '@module/lib/utils';
import useIsDarkModeStore from '@module/stores/useIsDarkModeStore';
import type { EventAnimCoinMessage, LayoutChatMessage } from '@module/types/centrifuge/public-message/eventMessageTypes';
interface Props {
  fontSizeClass?: string;
  item: LayoutChatMessage | EventAnimCoinMessage;
}
export default function LayoutChat(t0) {
  const $ = _c(19);
  const {
    fontSizeClass,
    item
  } = t0;
  const isDark = useIsDarkModeStore(_temp);
  const {
    message
  } = item.data;
  const messageText = message.message;
  const {
    messageHTML
  } = message;
  const {
    header
  } = message.opt.layout[isDark ? "black" : "white"];
  const {
    middle
  } = message.opt.layout[isDark ? "black" : "white"];
  const {
    footer
  } = message.opt.layout[isDark ? "black" : "white"];
  const {
    fontColor
  } = message.opt.layout[isDark ? "black" : "white"];
  let middleStyle;
  if ($[0] !== fontColor || $[1] !== middle) {
    middleStyle = {};
    if (middle) {
      if (middle.img) {
        middleStyle.background = `url('${middle.img}') repeat-y left top / 100% auto`;
      }
      if (middle.width) {
        middleStyle.width = `${middle.width}px`;
      }
      if (fontColor) {
        middleStyle.color = fontColor;
      }
    }
    $[0] = fontColor;
    $[1] = middle;
    $[2] = middleStyle;
  } else {
    middleStyle = $[2];
  }
  let t1;
  if ($[3] !== fontSizeClass) {
    t1 = cn("layout-chat-message", fontSizeClass);
    $[3] = fontSizeClass;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== header) {
    t2 = header && <img src={header.img} alt="header" className="header" height={header.height} width={header.width} />;
    $[5] = header;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== messageHTML || $[8] !== messageText || $[9] !== middle || $[10] !== middleStyle) {
    t3 = messageHTML ? <div className={cn("middle", {
      default: !middle
    })} dangerouslySetInnerHTML={{
      __html: messageHTML
    }} style={middleStyle} /> : <div className={cn("middle", {
      default: !middle
    })} style={middleStyle}>{messageText}</div>;
    $[7] = messageHTML;
    $[8] = messageText;
    $[9] = middle;
    $[10] = middleStyle;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== footer) {
    t4 = footer && <img src={footer.img} alt="footer" className="footer" height={footer.height} width={footer.width} />;
    $[12] = footer;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
function _temp(state) {
  return state.isDark;
}